import { createFileRoute } from '@tanstack/react-router'
import { ForgingsIndicationsPage } from 'pages/forgingsIndications/ForgingsIndicationsPage'

export const Route = createFileRoute('/forgings-indications/$inspectionId')({
  component: RouteComponent,
  staticData: {
    title: 'UT Indications',
    layout: {
      defaultClosedNav: true,
      enforceMaxWidth: false,
    },
  },
})

function RouteComponent() {
  const { inspectionId } = Route.useParams()
  return <ForgingsIndicationsPage inspectionId={inspectionId} />
}
